import { render, staticRenderFns } from "./ticketActivity.vue?vue&type=template&id=5e70091d"
import script from "./ticketActivity.vue?vue&type=script&lang=js"
export * from "./ticketActivity.vue?vue&type=script&lang=js"
import style0 from "./ticketActivity.vue?vue&type=style&index=0&id=5e70091d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports